import { h } from "preact";

import { getSeverityInformation, getEffectiveDateText } from "../../utils";
import styles from "./styles.scss";

const SystemAlert = props => {
    let { alert } = props;
    let { title, cause, effect, description, url, start_time, end_time } = alert;
    let {icon} = getSeverityInformation(cause, effect);
    let dateText = getEffectiveDateText(start_time, end_time);
    return (
        <div class={styles.systemAlert}>
            <h3>
                <span class={styles.severityIcon}>{icon}</span>
                <span class={styles.title}>{title.en}</span>
            </h3>
            <div>
                {description.en}
                {dateText &&
                    <div class={styles.dateText}>{dateText}</div>
                }
            </div>
        </div>
    );
};

export default SystemAlert;


// WEBPACK FOOTER //
// ./components/Alert/SystemAlert.js